import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Planta } from '../../models/planta';
import { ModelElectrico } from 'src/app/aplicaciones-modulos/tvc/models/modelElectrico';

@Injectable({
  providedIn: 'root'
})
export class PlantaService {

  headers: HttpHeaders;
  tvcModulo;
  urlPlanta;

  constructor(private http: HttpClient, private utilService: UtilsService) {
    this.tvcModulo = moduloPerform;
    this.urlPlanta = this.utilService.getQueryTvc( this.tvcModulo.url.datosMaestros.planta);
  }

  getAll() {
    const headers = this.utilService.getHeaders();
    return this.http.get<Planta []>( this.urlPlanta, {headers});
  }

  getReporteElectricista(planta:number){
    const headers = this.utilService.getHeaders();
    return this.http.get<ModelElectrico []>( this.utilService.getQueryTvc_1( this.tvcModulo.url.parada.electricista)+"/"+planta, {headers});
  }

  save( innPlanta ) {
    const headers = this.utilService.getHeaders();
    return this.http.post<Planta>(this.urlPlanta, innPlanta, { headers});
  }

  update( innPlanta) {
    const headers = this.utilService.getHeaders();
    return this.http.put<Planta>(this.urlPlanta, innPlanta, { headers});
  }

  delete( inId ) {
    const headers = this.utilService.getHeaders();
    return this.http.delete(this.urlPlanta + '/' + inId, { headers});
  }

  updateCentroCosto(innObjPlanta: any) {
    const headers = this.utilService.getHeaders();
    return this.http.put<Planta>(this.urlPlanta + '/centro-costo', innObjPlanta, { headers});
  }

  getAllbySap() {
    const headers = this.utilService.getHeaders();
    return this.http.get<Planta []>( this.urlPlanta+'/sap', {headers});
  }

  getAllbyPerfor() {
    const headers = this.utilService.getHeaders();
    return this.http.get<Planta []>( this.utilService.getQueryTvc( this.tvcModulo.url.datosMaestros.plantaPerfor), {headers});
  }

  getAllbyPerforByUser(user : string) {
    const headers = this.utilService.getHeaders();
    return this.http.get<Planta []>( this.utilService.getQueryTvc( this.tvcModulo.url.datosMaestros.plantaPerforByUser + user), {headers});
  }


  // Por linea y por Planta
  getReporteElectricistaPlantaLinea(planta:number, linea:number){
    const headers = this.utilService.getHeaders();
    return this.http.get<ModelElectrico []>( this.utilService.getQueryTvc_1( this.tvcModulo.url.parada.electricista)+"/"+planta+"/"+linea, {headers});
  }

}
